import axios, { AxiosResponse } from 'axios';
import Cookies from 'universal-cookie';

import {
  CodeVerificationRequest,
  CodeVerificationResponse,
  EventDetailApiResponse,
  EventRegisterResponse,
  EventsListApiResponse,
  UserMetricsApiResponse,
  UserStatusApiResponse,
} from '../routes/referral/types/api.types';

import { RewardDistributionHistoryResponse } from '../routes/singleEvent/types/reward-distribution.types';

import { CookiesKeys } from '../enums/cookies-keys.enum';

export const getReferralEventService = (
  eventId: string,
  signal: AbortSignal
): Promise<AxiosResponse<EventDetailApiResponse>> => {
  return axios.get(`/api/v1/events/${eventId}/`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

export const registerForEventService = (eventId: string): Promise<AxiosResponse<EventRegisterResponse>> => {
  return axios.post(
    `/api/v1/events/${eventId}/register/`,
    {},
    {
      headers: {
        'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
      },
    }
  );
};

export const unregisterFromEventService = (eventId: string): Promise<AxiosResponse<EventRegisterResponse>> => {
  return axios.post(
    `/api/v1/events/${eventId}/unregister/`,
    {},
    {
      headers: {
        'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
      },
    }
  );
};

export const getUserMetricsService = (
  eventId: string,
  signal: AbortSignal
): Promise<AxiosResponse<UserMetricsApiResponse>> => {
  return axios.get(`/api/v1/events/${eventId}/user-metrics/`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

export const getUserStatusService = (
  eventId: string,
  signal: AbortSignal
): Promise<AxiosResponse<UserStatusApiResponse>> => {
  return axios.get(`/api/v1/events/${eventId}/user-status/`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

export const getEventsListService = (
  eventType: 'referral' | 'trading' | 'all',
  signal: AbortSignal
): Promise<AxiosResponse<EventsListApiResponse>> => {
  return axios.get('/api/v1/events/', {
    signal,
    params: eventType === 'all' ? {} : { event_type: eventType },
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

export const verifyEventCodeService = (
  eventId: string,
  code: string
): Promise<AxiosResponse<CodeVerificationResponse>> => {
  const requestData: CodeVerificationRequest = { code };
  return axios.post(`/api/v1/events/${eventId}/verify-code/`, requestData, {
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

export const getRewardDistributionHistoryService = (
  eventId: string,
  signal: AbortSignal,
  page: number = 1,
  pageSize: number = 5
): Promise<AxiosResponse<RewardDistributionHistoryResponse>> => {
  return axios.get(`/api/v1/events/${eventId}/reward-history/`, {
    signal,
    params: {
      page,
      page_size: pageSize,
    },
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};
